var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('vue-aos', {
    attrs: {
      "animation-class": "animate__zoomInLeft animate__animated"
    }
  }, [_c('v-row', {
    staticStyle: {
      "height": "80vh"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('v-card', {
    staticClass: "pa-10 rounded-lg",
    attrs: {
      "elevation": "10",
      "color": "rgba(255, 255, 255, 0.9)"
    }
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/img/siglasigfoco.svg",
      "alt": "brasão-home-64px"
    }
  }), _c('h1', {
    staticClass: "subtitle-1 blue--text text--darken-4 mt-4 font-weight-bold"
  }, [_vm._v(" Definir Nova Senha ")])])], 1), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-text-field', {
    staticClass: "rounded-lg",
    attrs: {
      "solo": "",
      "placeholder": "Senha Atual*",
      "type": "password",
      "maxlength": "256",
      "rules": _vm.senhaRules(),
      "outlined": "",
      "dense": "",
      "prepend-inner-icon": "mdi-account"
    },
    model: {
      value: _vm.user.senhaAtual,
      callback: function ($$v) {
        _vm.$set(_vm.user, "senhaAtual", $$v);
      },
      expression: "user.senhaAtual"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-text-field', {
    staticClass: "rounded-lg",
    attrs: {
      "solo": "",
      "placeholder": "Nova Senha*",
      "type": "password",
      "maxlength": "256",
      "rules": _vm.novaSenhaRules(),
      "outlined": "",
      "dense": "",
      "prepend-inner-icon": "mdi-lock"
    },
    model: {
      value: _vm.user.novaSenha,
      callback: function ($$v) {
        _vm.$set(_vm.user, "novaSenha", $$v);
      },
      expression: "user.novaSenha"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-text-field', {
    staticClass: "rounded-lg",
    attrs: {
      "solo": "",
      "placeholder": "Confirmar a Nova Senha*",
      "type": "password",
      "maxlength": "256",
      "rules": _vm.confirmarSenhaRules(),
      "outlined": "",
      "dense": "",
      "prepend-inner-icon": "mdi-lock"
    },
    model: {
      value: _vm.user.confirmarSenha,
      callback: function ($$v) {
        _vm.$set(_vm.user, "confirmarSenha", $$v);
      },
      expression: "user.confirmarSenha"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-btn', {
    staticClass: "py-4 px-6 mr-3 rounded-lg",
    attrs: {
      "color": "success",
      "loading": _vm.loading
    },
    on: {
      "click": function ($event) {
        return _vm.recuperarSenha();
      }
    }
  }, [_vm._v(" Salvar ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }